var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('decision-form'),_c('panel',[_c('w-button',{staticClass:"btn-secondary",attrs:{"text":"Wróć"},on:{"click":_vm.goBack}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }